module.exports = __webpack_public_path__ + "img/dsj_py.fab79ef7.png";